import { BaseChip } from '@domains/chips';
import { City } from '@domains/common-data';
import { NewsType } from '@domains/news';
import { PaymentMethod, ReceivingMethod } from '@domains/order';

export const ISRRevalidateConfigInMinutes = {
    NotFound: 5,
};

export const ARTICLE_TYPES: Record<NewsType, string> = {
    news: 'Новости',
    promotion: 'Акции',
};

export const RANGE_DATE_PLACEHOLDER_TEXT = 'Скоро укажем';

export const FORMAT = {
    ruPhoneNumber: '+# (###) ###-##-##',
    code: '####',
    inn12: '############',
    selectedWholesale: '########################################',
};

export const COUNTRY_PHONE_CODES = {
    ru: '7',
};

export const nonBreakableSpace = '\xa0';

export const TOTAL_BLOCK_LABELS = {
    products: 'Товара(-ов):',
    sum: 'Сумма',
    discount: 'Скидка',
    toPay: 'К оплате',
    delivery: 'Доставка',
    pickup: 'Самовывоз',
    deliveryDate: 'Дата доставки',
    pickupDate: 'Дата',
    orderAmount: 'Сумма заказа',
    paymentMethod: 'Способ оплаты',
    paymentStatus: 'Статус оплаты',
};

export const DEFAULT_PAGE_SIZE = 9;
export const DEFAULT_PAGE_SIZE_RECIPES = 18;

export const REG_EXP_RULES = {
    email: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
    ruPhone: /^(?:\+7|7|8)(\d{3})(\d{3})(\d{2})(\d{2})/i,
    onlyDigits: /\D/g,
    inn: /^\d{10}(\d{1,2})?$/,
};

export const VALIDATION_MESSAGES = {
    required: 'Обязательное поле',
    email: 'Например: pochta@mail.ru',
    min: 'Слишком мало символов',
    max: 'Слишком много символов',
    common: 'Неверное значение',
    message: 'от 3 до 2000 символов',
    max100: 'Максимальная длинна 100 символов',
    phone: 'Введите корректный номер телефона',
    city: 'Введите населённый пункт',
    streetHouse: 'Введите улицу и дом',
    inn: 'ИНН должен содержать 10 или 12 цифр, проверьте введенные данные.',
};

export const VALIDATORS = {
    nameValidator: (value: string) => {
        if (value === undefined || value === '') return true;
        return value.length <= 100 ? true : VALIDATION_MESSAGES.max100;
    },
    phoneValidator: (value: string) => {
        const numbers = value.replace(REG_EXP_RULES.onlyDigits, '');
        return numbers.match(REG_EXP_RULES.ruPhone) ? true : VALIDATION_MESSAGES.phone;
    },
    innValidator: (value: string) => {
        return value.match(REG_EXP_RULES.inn) ? true : VALIDATION_MESSAGES.inn;
    },
    emailValidator: (value: string) => {
        if (value === undefined || value === '') return true;
        return value.match(REG_EXP_RULES.email) ? true : VALIDATION_MESSAGES.email;
    },
    messageValidator: (value: string | undefined) => {
        if (value === undefined || value === '') return true;
        return value.length >= 3 && value.length <= 3000 ? true : VALIDATION_MESSAGES.message;
    },
    codeValidator: (value: string | undefined) => {
        if (value === undefined || value === '') return true;
        return value.replace('#', '').length === 4 ? true : VALIDATION_MESSAGES.min;
    },
    isChecked: (value: boolean) => (value === true ? true : VALIDATION_MESSAGES.required),
};

export const ALL_RECIPES_CHIP_ID = 'all-recipes';
export const ALL_RECIPES_CHIP_BASE: BaseChip = {
    id: ALL_RECIPES_CHIP_ID,
    caption: 'Все рецепты',
};

export const CHECKOUT_OTHER_CITY: Pick<City, 'name' | 'fias_id'> = {
    name: 'Другой населённый пункт',
    fias_id: 'another_city',
};

export const PAYMENT_METHOD_NAME: Record<PaymentMethod, string> = {
    [PaymentMethod.YooKassa]: 'Картой на сайте',
    [PaymentMethod.CashUponReceipt]: 'Наличными',
    [PaymentMethod.CardUponReceipt]: 'Картой',
};

export const RECEIVING_METHOD_NAME_FOR_PAYMENT: Record<ReceivingMethod, string> = {
    [ReceivingMethod.Courier]: ' курьеру',
    [ReceivingMethod.Pickup]: ' при получении',
};

export const PromoPageSlug = 'skidki' as const;
export const NewProductsPageSlug = 'novinki' as const;
